<template>
  <div class="content">
    <h2>Recommendations</h2>
    <div class="recomendations carousel">
      <div class="movie carousel__container">
        <div
          class="carousel-item movie--item"
          v-for="item in showDetail.recommendations"
          :key="item.id"
        >
          <router-link :to="`/detail/${item.id}/${item.slug}`">
            <figure class="movie-img">
              <img class="image" :src="item.imageUrl" :alt="item.title" />
            </figure>
          </router-link>
        </div>
      </div>
    </div>
    <button class="icon-carousel icon-prev" @click="prev">
      <font-awesome-icon icon="chevron-left" />
    </button>
    <button class="icon-carousel icon-next" @click="next">
      <font-awesome-icon icon="chevron-right" />
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({}),

  computed: mapState(["showDetail"]),
  methods: {
    prev: function () {
      var last = this.showDetail.recommendations.pop();
      this.showDetail.recommendations.splice(0, 0, last);
    },
    next: function () {
      var first = this.showDetail.recommendations.shift();
      this.showDetail.recommendations.push(first);
    },
  },
};
</script>

<style scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-move {
  transform: translateX(0);
  transform: translate3d(0, 0, 0);
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.content {
  position: relative;
}
.recomendations {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 100%;
  justify-content: center;
}
h2 {
  font-weight: 400;
  border-bottom: 1px solid #738092;
}

.movie-item {
  margin: 0;
}

.movie-img {
  width: 160px;
  height: 240px;

  margin: 0;
}
.image {
  vertical-align: top;
  border-radius: 15px;
  width: 160px;
  height: 240px;
  object-fit: cover;
  cursor: pointer;
}

/* CAROUSEL */
.carousel {
  overflow: scroll;
  width: 100%;
  position: relative;
}

.carousel__container {
  transition: 450ms -webkit-transform;
  transition: 450ms transform;
  transition: 450ms transform, 450ms -webkit-transform;
  font-size: 0;
  white-space: nowrap;
  padding-bottom: 10px;
  margin-top: 15px;
}

.carousel__container:hover .carousel-item:hover {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
  opacity: 1;
}

.carousel-item {
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.carousel-item:hover ~ .carousel-item {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

.carousel-item__img {
  width: 95px;
  -o-object-fit: cover;
  object-fit: cover;
}

::-webkit-scrollbar {
  display: none;
}

.icon-carousel {
  background: rgba(0, 0, 0, 0);
  color: rgba(0, 0, 0, 0);
  border: 0px solid #9e9e9e;
  padding: 5px;
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  bottom: 10px;
  height: 240px;
  width: 40px;
}
.icon-carousel:hover {
  background: rgba(0, 0, 0, 0.9);
  color: white;
}

.icon-prev {
  left: 0px;
}

.icon-next {
  right: 0px;
}
/* FIN CAROUSEL */

@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
}

@media (max-width: 600px) {
  .image {
    border-radius: 15px;
    width: 150px;
    height: 225px;
  }
}
</style>
